import { Navigate } from 'react-router-dom';
import { useAuthContext } from '@/context/AuthContext';

const DashboardRedirect = () => {
  const { userType, userLoading, isLoading, user, isAuthenticated } = useAuthContext();

  const isLoadingState = isLoading || userLoading;
  if (isLoadingState) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p>Loading dashboard...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  switch (userType) {
    case 'superadmin':
      return <Navigate to="/super-admin/organizations" replace />;
    case 'nonprofit':
    case 'child_user':
      return <Navigate to="/assessment" replace />;
    default:
      return (
        <div className="flex justify-center items-center min-h-screen">
          <div className="text-center">
            <h2 className="text-xl text-red-600 mb-4">Unknown User Type</h2>
            <p className="text-gray-600 mb-4">
              Your account type ({userType || 'unknown'}) is not recognized.
            </p>
            <p className="text-sm text-gray-500">
              Please contact support or try logging in again.
            </p>
          </div>
        </div>
      );
  }
};

export default DashboardRedirect;